import { AddButtonComponent } from './add-button/add-button.component';
import { ConfirmDialogComponent } from './confirm-dialog/confirm-dialog.component';
import { ChipInputComponent } from './chip-input/chip-input.component';
import { UnderConstructionComponent } from './under-construction/under-construction.component';
import { TableHeaderComponent } from './table-header/table-header.component';
import { SingleInputComponent } from './single-input/single-input.component';
import { DataTableComponent } from './data-table/data-table.component';
import { HttpTableComponent } from './http-table/http-table.component';
import { TabsHeaderComponent } from './tabs-header/tabs-header.component';
import { CommentsIconComponent } from './comments-icon/comments-icon.component';
import { LoadingButtonComponent } from './loading-button/loading-button.component';
import { ChangePasswordFormComponent } from '@ml/shared/components/change-password-form/change-password-form.component';
import { PromptDialogComponent } from '@ml/shared/components/prompt-dialog/prompt-dialog.component';
import { LogoCardComponent } from '@ml/shared/components/logo-card/logo-card.component';
import { FilterableSelectComponent } from '@ml/shared/components/filterable-select/filterable-select.component';
import { SelectComponent } from '@ml/shared/components/select/select.component';
import { MeasurementUnitFormComponent } from './measurement-unit-form/measurement-unit-form.component';
import { InputComponent } from '@ml/shared/components/input/input.component';
import { DialogActionsComponent } from './dialog-actions/dialog-actions.component';
import { EmptyTableComponent } from '@ml/shared/components/empty-table/empty-table.component';
import { TablePaginatorComponent } from '@ml/shared/components/table-paginator/table-paginator.component';
import { CustomerLocationModalComponent } from './customer-location-modal/customer-location-modal.component';
import { ChipsAutocompleteComponent } from './chips-autocomplete/chips-autocomplete.component';
import { DatePickerComponent } from '@ml/shared/components/date-picker/date-picker.component';
import { OrderLocationsTableComponent } from './order-locations-table/order-locations-table.component';
import { OrderLocationStatusComponent } from '@ml/shared/components/order-location-status/order-location-status.component';
import { SelectLocationsTableComponent } from '@ml/shared/components/select-locations-table/select-locations-table.component';
import { OrdersFiltersComponent } from '@ml/shared/components/orders-filters/orders-filters.component';
import { OrderLocationsMapComponent } from '@ml/shared/components/order-locations-map/order-locations-map.component';
import { CustomerLocationPinComponent } from '@ml/shared/components/customer-location-pin/customer-location-pin.component';
import { LocationsMoveDialogComponent } from './locations-move-dialog/locations-move-dialog.component';
import { ListDialogComponent } from './list-dialog/list-dialog.component';

export const components = [
  AddButtonComponent,
  TableHeaderComponent,
  ConfirmDialogComponent,
  ChipInputComponent,
  UnderConstructionComponent,
  SingleInputComponent,
  DataTableComponent,
  HttpTableComponent,
  TabsHeaderComponent,
  CommentsIconComponent,
  LoadingButtonComponent,
  ChangePasswordFormComponent,
  PromptDialogComponent,
  LogoCardComponent,
  FilterableSelectComponent,
  SelectComponent,
  MeasurementUnitFormComponent,
  InputComponent,
  DialogActionsComponent,
  EmptyTableComponent,
  CustomerLocationModalComponent,
  TablePaginatorComponent,
  ChipsAutocompleteComponent,
  DatePickerComponent,
  OrderLocationsTableComponent,
  OrderLocationStatusComponent,
  SelectLocationsTableComponent,
  OrdersFiltersComponent,
  OrderLocationsMapComponent,
  CustomerLocationPinComponent,
  LocationsMoveDialogComponent,
  ListDialogComponent
];

export const entryComponent = [
  ConfirmDialogComponent,
  PromptDialogComponent,
  CustomerLocationModalComponent,
  LocationsMoveDialogComponent,
  ListDialogComponent
];

export * from './add-button/add-button.component';
export * from './confirm-dialog/confirm-dialog.component';
export * from './chip-input/chip-input.component';
export * from './under-construction/under-construction.component';
export * from './table-header/table-header.component';
export * from './single-input/single-input.component';
export * from './data-table/data-table.component';
export * from './http-table/http-table.component';
export * from './tabs-header/tabs-header.component';
export * from './comments-icon/comments-icon.component';
export * from './loading-button/loading-button.component';
export * from './change-password-form/change-password-form.component';
export * from './prompt-dialog/prompt-dialog.component';
export * from './logo-card/logo-card.component';
export * from './customer-location-modal/customer-location-modal.component';
